import { z } from 'zod';

/** Where the web app finds its Cognito user pool (QZ-D18, QZ-D28). `domain` is a bare host, e.g. `auth-dev.gpsquizdb.com`. */
export const authConfigSchema = z
  .object({
    region: z.string().min(1),
    userPoolId: z.string().min(1),
    clientId: z.string().min(1),
    domain: z.string().min(1),
  })
  .strip();
export type AuthConfig = z.infer<typeof authConfigSchema>;
